// Cute Futures — Shopify-aware cart drawer.
// Talks to /cart.js for state, /cart/add.js to add, /cart/change.js to update lines.
(function () {
  var FREE_SHIP = window.CF_FREE_SHIP_THRESHOLD || 25;
  var ROUTES = window.CF_ROUTES || { cart: '/cart', cart_add: '/cart/add.js', cart_change: '/cart/change.js', checkout: '/checkout' };

  function moneyFromCents(cents) {
    if (cents == null) return '$0.00';
    return '$' + (cents / 100).toFixed(2);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function injectDrawer() {
    if (document.getElementById('cf-drawer')) return;
    var html = '\n' +
      '<div class="cf-drawer" id="cf-drawer" aria-hidden="true">\n' +
      '  <div class="cf-drawer__overlay" data-cart-close></div>\n' +
      '  <aside class="cf-drawer__panel" role="dialog" aria-label="Your bag">\n' +
      '    <div class="cf-drawer__header">\n' +
      '      <button class="cf-drawer__back" data-cart-close aria-label="Back to shopping">\n' +
      '        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>\n' +
      '        <span>Keep shopping</span>\n' +
      '      </button>\n' +
      '      <h2 class="cf-drawer__title">Your bag <span class="cf-drawer__count" id="cf-drawer-count">(0)</span></h2>\n' +
      '      <button class="cf-drawer__close" data-cart-close aria-label="Close">\n' +
      '        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>\n' +
      '      </button>\n' +
      '    </div>\n' +
      '    <div class="cf-drawer__ship">\n' +
      '      <p class="cf-drawer__ship-msg" id="cf-ship-msg">Add $25 for FREE shipping</p>\n' +
      '      <div class="cf-drawer__ship-track"><div class="cf-drawer__ship-fill" id="cf-ship-fill"></div></div>\n' +
      '    </div>\n' +
      '    <div class="cf-drawer__items" id="cf-drawer-items"></div>\n' +
      '    <div class="cf-drawer__summary" id="cf-drawer-summary"></div>\n' +
      '    <button class="cf-drawer__checkout" id="cf-drawer-checkout">Checkout · <span id="cf-drawer-total">$0.00</span></button>\n' +
      '    <button class="cf-drawer__keep" data-cart-close>← Keep shopping</button>\n' +
      '    <p class="cf-drawer__pay">Secure checkout with <strong>Shop Pay · Apple Pay · PayPal · Visa · MC</strong></p>\n' +
      '  </aside>\n' +
      '</div>';
    document.body.insertAdjacentHTML('beforeend', html);
  }

  function setHeaderCount(n) {
    document.querySelectorAll('[data-cf-cart-count]').forEach(function (el) {
      el.textContent = n;
    });
    document.querySelectorAll('.cf-cart').forEach(function (el) {
      el.classList.toggle('has-items', n > 0);
    });
  }

  function renderDrawer(cart) {
    var itemsEl = document.getElementById('cf-drawer-items');
    var countEl = document.getElementById('cf-drawer-count');
    if (!itemsEl) return;
    var qty = cart.item_count || 0;
    var origTotal = cart.original_total_price || 0;
    var finalTotal = cart.total_price || 0;
    var totalDiscount = cart.total_discount || (origTotal - finalTotal);
    if (totalDiscount < 0) totalDiscount = 0;
    countEl.textContent = '(' + qty + ')';

    if (qty === 0) {
      itemsEl.innerHTML = '<div class="cf-drawer__empty"><div class="cf-drawer__empty-icon">🛒</div><h3>Your bag is empty</h3><p>Pick a character to get started.</p><a class="cf-btn" href="/#shop">Shop the covers →</a></div>';
    } else {
      itemsEl.innerHTML = (cart.items || []).map(function (item) {
        var thumb = item.image ? '<img src="' + item.image + '" alt="">' : '';
        var orig = item.original_line_price || (item.original_price * item.quantity);
        var fin  = item.final_line_price || (item.final_price * item.quantity);
        var hasDiscount = orig > fin;
        var priceHtml = hasDiscount
          ? '<s style="color:#999;font-weight:500;margin-right:.4em;">' + moneyFromCents(orig) + '</s>' + moneyFromCents(fin)
          : moneyFromCents(fin);
        var discountLabels = '';
        if (item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
          discountLabels = item.line_level_discount_allocations.map(function (a) {
            var raw = (a.discount_application && a.discount_application.title) || 'Discount';
            // Pretty-print "N for X%" → "N+ for X%" so customers see it as a threshold, not an exact qty
            var pretty = raw.replace(/^(\d+)\s+for\s+(.+)$/i, '$1+ for $2');
            return '<span class="cf-drawer__disc-tag">' + pretty + '</span>';
          }).join('');
        }
        return (
          '<div class="cf-drawer__item' + (hasDiscount ? ' has-disc' : '') + '" data-key="' + item.key + '">' +
            '<a class="cf-drawer__thumb" href="' + item.url + '">' + thumb + '</a>' +
            '<div class="cf-drawer__meta">' +
              '<a class="cf-drawer__name" href="' + item.url + '">' + item.product_title + '</a>' +
              (discountLabels ? '<div class="cf-drawer__disc-row">' + discountLabels + '</div>' : '') +
              '<div class="cf-drawer__row">' +
                '<div class="cf-drawer__qty">' +
                  '<button data-cart-act="dec" data-key="' + item.key + '">−</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button data-cart-act="inc" data-key="' + item.key + '">+</button>' +
                '</div>' +
                '<span class="cf-drawer__price">' + priceHtml + '</span>' +
              '</div>' +
            '</div>' +
            '<button class="cf-drawer__rm" data-cart-act="rm" data-key="' + item.key + '" aria-label="Remove">' +
              '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
            '</button>' +
          '</div>'
        );
      }).join('');
    }

    var threshCents = FREE_SHIP * 100;
    var pct = Math.min(100, Math.round((finalTotal / threshCents) * 100));
    var remaining = Math.max(0, threshCents - finalTotal);
    document.getElementById('cf-ship-fill').style.width = pct + '%';
    var msg = document.getElementById('cf-ship-msg');
    if (qty === 0) msg.innerHTML = 'Add $25 for FREE shipping';
    else if (remaining > 0) msg.innerHTML = 'Add <strong>' + moneyFromCents(remaining) + '</strong> for FREE shipping';
    else msg.innerHTML = '<strong>You unlocked free shipping ✨</strong>';

    var summaryHtml =
      '<div class="cf-drawer__sumrow"><span>Subtotal</span><span>' + moneyFromCents(origTotal) + '</span></div>';
    if (totalDiscount > 0) {
      summaryHtml +=
        '<div class="cf-drawer__sumrow cf-drawer__save"><span>Bundle discount</span><span>−' + moneyFromCents(totalDiscount) + '</span></div>';
    }
    summaryHtml +=
      '<div class="cf-drawer__sumrow"><span>Shipping</span><span>' + (qty === 0 ? '$0.00' : (finalTotal >= threshCents ? 'FREE' : 'Calculated at checkout')) + '</span></div>' +
      '<div class="cf-drawer__sumrow cf-drawer__total"><span>Total</span><span>' + moneyFromCents(finalTotal) + '</span></div>';
    document.getElementById('cf-drawer-summary').innerHTML = summaryHtml;
    document.getElementById('cf-drawer-total').textContent = moneyFromCents(finalTotal);
    var checkoutBtn = document.getElementById('cf-drawer-checkout');
    if (checkoutBtn) checkoutBtn.disabled = qty === 0;
    setHeaderCount(qty);
  }

  function refresh(open) {
    return fetchCart().then(function (cart) {
      renderDrawer(cart);
      if (open) openDrawer();
      return cart;
    });
  }

  function openDrawer() {
    var d = document.getElementById('cf-drawer');
    if (!d) return;
    d.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = document.getElementById('cf-drawer');
    if (!d) return;
    d.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function changeLine(key, qty) {
    return fetch(ROUTES.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    injectDrawer();
    refresh(false);

    // Header cart icon → open drawer (don't navigate to /cart)
    document.querySelectorAll('[data-cf-cart-trigger]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        refresh(true);
      });
    });

    // Drawer interaction (close + line qty/remove)
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) {
        closeDrawer();
        return;
      }
      var btn = e.target.closest('[data-cart-act]');
      if (!btn) return;
      var act = btn.dataset.cartAct;
      var key = btn.dataset.key;
      if (!key) return;
      // find current qty from the rendered span
      var item = btn.closest('.cf-drawer__item');
      var qtySpan = item ? item.querySelector('.cf-drawer__qty span') : null;
      var current = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;
      var next;
      if (act === 'inc') next = current + 1;
      else if (act === 'dec') next = current - 1;
      else if (act === 'rm') next = 0;
      changeLine(key, next).then(function (cart) { renderDrawer(cart); });
    });

    // Checkout
    var checkoutBtn = document.getElementById('cf-drawer-checkout');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        window.location.href = ROUTES.checkout;
      });
    }

    // Esc closes drawer
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    // Listen for add-to-cart events from anywhere
    document.addEventListener('cf:cart:added', function () { refresh(true); });
  });
})();
